<template>
  <t-card style="margin-top: -20px">
    <t-form
      ref="managerInfoForm"
      :model="managerInfoForm"
      label-position="right"
      label-width="100px"
      domain="managerInfoForm"
      class="managerInfoForm"
    >
      <t-row>
        <!-- 会社名 -->
        <t-col :span="12">
          <t-form-item :label="$t('resource.managerMstInfo.mgrCompanyName')">
            <t-select
              v-model="managerInfoForm.mgrCusName"
              clearable
              class="select-width"
              :disabled="disabled"
              :placeholder="$t('resource.sys.hidden')"
            >
              <t-option
                v-for="item in mgrCusNameList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </t-option>
            </t-select> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <!-- 担当者名 -->
        <t-col :span="12">
          <t-form-item
            :label="$t('resource.managerMstInfo.mgrName')"
            prop="mgrName"
          >
            <t-input
              v-model="managerInfoForm.mgrName"
              maxLength="15"
            ></t-input> </t-form-item
        ></t-col>

        <t-col :span="12">
          <!-- 担当者略称 -->
          <t-form-item
            :label="$t('resource.managerMstInfo.mgrAbbreviation')"
            prop="mgrAbbreviation"
          >
            <t-input
              v-model="managerInfoForm.mgrAbbreviation"
              maxLength="40"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- mgrSex -->
          <t-form-item :label="$t('resource.managerMstInfo.mgrSex')">
            <t-select
              v-model="managerInfoForm.mgrSex"
              clearable
              class="select-width"
              :placeholder="$t('resource.sys.hidden')"
            >
              <t-option
                v-for="item in mgrSexList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </t-option>
            </t-select> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- TEL -->
          <t-form-item
            :label="$t('resource.managerMstInfo.mgrTel')"
            prop="mgrTel"
          >
            <t-input
              v-model="managerInfoForm.mgrTel"
              maxLength="15"
            ></t-input></t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- Mail -->
          <t-form-item
            :label="$t('resource.managerMstInfo.mgrMail')"
            prop="mgrMail"
          >
            <t-input
              v-model="managerInfoForm.mgrMail"
              maxLength="20"
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 役職 -->
          <t-form-item
            :label="$t('resource.managerMstInfo.mgrPosition')"
            prop="mgrPosition"
          >
            <t-input
              v-model="managerInfoForm.mgrPosition"
              maxLength="15"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row type="flex" justify="end">
        <div>
          <t-col :span="24">
            <t-button
              type="primary"
              style="width: 100px; height: 40px; align: center"
              class="button-default"
              @click="Confirm"
              >{{ $t("resource.sys.sure") }}</t-button
            >
          </t-col>
        </div>
      </t-row>
    </t-form>
  </t-card>
</template>
<script>
import { AddMgrMstInfo, ChangeMgrMstInfo } from "@/services/mangerInfo";
import { Message } from "@tellus/ui";
export default {
  data() {
    return {
      managerInfoForm: {},
      disabled: false,

      mgrSexList: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],

      mgrCusNameList: [],
    };
  },
  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
    dataList: {
      Type: Object,
    },
  },
  mounted() {
    if (!this.isAdd) {
      this.Init(this.rowData, this.dataList);
      this.disabled = true;
    }

    this.mgrCusNameList = this.dataList;
  },
  methods: {
    // 初期化
    Init(data) {
      this.managerInfoForm = data;
    },
    // 編集
    Confirm() {
      this.$refs.managerInfoForm.validate((valid) => {
        if (valid) {
          this.managerInfoForm.updateUser = localStorage.getItem("userId");

          // console.log(this.managerInfoForm);

          if (this.isAdd) {
            AddMgrMstInfo(this.managerInfoForm, () => {
              this.$emit("ok", "ok");
            }).catch((err) => {
              Message({
                type: "error",
                message: err.data.Messages[0].Message,
              });
            });
          } else {
            ChangeMgrMstInfo(this.managerInfoForm, () => {
              this.$emit("ok", "ok");
            });
          }
        }
      });
    },
    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input--prefix .el-input__inner {
  width: 269px;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 269px;
}
</style>
